<template>
    <div>
        <div class="app flex-row align-items-center">
        <b-container>
            <b-row class="justify-content-center">
                <b-col md="6">
                    <b-card no-body class="p-4">
                        <b-card-body>
                            <b-form v-on:submit.prevent="submit">
                                <b-alert :variant="alertvariant"
                                         dismissible
                                         :show="showDismissibleAlert"
                                         v-if="showDismissibleAlert"
                                         @dismissed="showDismissibleAlert=false">
                                  {{this.responses.message}}
                                </b-alert>
                                <!-- <p>{{this.responses.message}}</p> -->
                                <h1>Reset Password</h1>
                                <p class="text-muted">Reset password to your account</p>
                                <b-form-group
                                label="Email address:"
                                label-for="email"
                                :class="{ 'form-group--error': errors.collect('email') }"
                                class="mb-3"
                                >
                                    <b-form-input
                                    type="email"
                                    name="email"
                                    v-model="email"
                                    @input="sanitizeEmail($event)"
                                    aria-describedby="input-1-live-feedback"
                                    v-validate="{ required: true, email: email, max:60 }"
                                    :state="validateState('email')"
                                    placeholder="Enter email">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" v-if="errors.has('email')">
                                    {{errors.first('email')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                label="Enter New Password:"
                                label-for="password"
                                >
                                    <b-form-input
                                    type="password"
                                    name="password"
                                    v-model="password"
                                    @input="sanitizePassword($event)"
                                    v-validate="{ required: true, min:6 }"
                                    :state="validateState('password')"
                                    placeholder="Enter password">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="input-1-live-feedback" v-if="errors.has('password')">
                                    {{errors.first('password')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                label="Confirm Password:"
                                label-for="password"
                                >
                                    <b-form-input
                                    type="password"
                                    name="confirm_password"
                                    v-model="confirm_password"
                                    @input="sanitizeConfirmPassword($event)"
                                    v-validate="{ required: true, min:6, confirmed: password }"
                                    :state="validateState('confirm_password')"
                                    placeholder="Confirm password"
                                    data-vv-as="password">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors.has('confirm_password')">
                                    {{errors.first('confirm_password')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                <b-row>
                                    <b-col cols="6">
                                        <b-button type="submit" variant="primary" class="float-left">Submit</b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
    </div>
</template>

<script>
import axios from 'axios';
import { sanitizeInput } from '../../utils/sanitizer';
export default {
    name: "ResetPassword",
    data() {
        return {
            email: '',
            password: '',
            confirm_password: '',
            responses: '',
            showDismissibleAlert:false,
            alertvariant: ''
        }
    },
    created() {
        if(!this.$route.query.token) {
            this.$router.push('/login');
        }
        const dict = {
            custom: {
                email: {
                    required: "Please enter email.",
                    max: "email cannot be more than 60 characters.",
                    email: 'Please enter valid email address.'
                },
                password: {
                    required: "Please enter password.",
                    min: "password must be 6 characters."
                },
                confirm_password: {
                    required: "Please enter confirm password.",
                    min: "password must be 6 characters.",
                    confirmed: 'password does not match'
                }
            }
        };
        this.$validator.localize('en', dict);
    },
    methods: {
        sanitizeEmail($event) {
            this.email = sanitizeInput($event);
        },
        sanitizePassword($event) {
            this.password = sanitizeInput($event);
        },
        sanitizeConfirmPassword($event) {
            this.confirm_password = sanitizeInput($event);
        },
        submit: function() {
            this.$validator.validateAll().then(result => {
                if(result) {
                    this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/dashboard/reset-password`, {email: this.email, password: this.password, token: this.$route.query.token}).then(response => {
                        if(response.data.success) {
                            this.responses = response.data;
                            this.alertvariant = 'success';
                            this.showDismissibleAlert=true;
                            setTimeout(() => {
                                this.$router.push('/login');
                            }, 1000);
                        }else if(response.data.success == false){
                            this.responses = response.data;
                            this.alertvariant = 'danger';
                            this.showDismissibleAlert=true;
                        }
                    });
                }
            });
        },
        validateState(ref) {
            if (this.errors.has(ref)) {
                //console.log('this.errors.has(ref)',this.errors);
              return !this.errors.has(ref);
            } else {
                return null;
            }
        }
    }
}
</script>